import { AnnouncementEntitiesState } from './announcement-entities.state';
import { announcementEntitiesAdapter } from './announcement-entities.adapter';

/**
 * Initialer State für Announcement-Entities.
 */
export const announcementEntitiesStateInitial: AnnouncementEntitiesState =
  announcementEntitiesAdapter.getInitialState({
    statistics: null,
    totalElements: 0,
    isLoadingList: false,
    isListLoaded: false,
    isLoadingStatistics: false,
    isStatisticsLoaded: false,
    deletingIds: [],
    publishingIds: [],
    listError: null,
    statisticsError: null,
  });
